"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const elements_1 = require("@src/components/elements");
const account_deletion_1 = require("@src/constants/account-deletion");
const localized_path_1 = require("@shared/localized-path");
const theme_1 = require("@src/styles/theme");
const { Title } = antd_1.Typography;
const LayoutCol = (0, styled_components_1.default)(antd_1.Col) `
	max-width: 36rem;
	margin-left: auto;
	margin-right: auto;
`;
const ThankYouPanel = (0, styled_components_1.default)(elements_1.Panel) `
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 2rem 1.5rem 2.25rem;

	@media (min-width: ${theme_1.theme.breakpoints.md}) {
		padding: 2.5rem 2rem 2.75rem;
	}
`;
const IconWrap = styled_components_1.default.div `
	width: 5.5rem;
	height: 5.5rem;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1.25rem;
	background: ${(0, polished_1.transparentize)(0.88, theme_1.theme.color.success)};
	box-shadow: ${theme_1.theme.boxShadow.hover};
`;
const Lead = styled_components_1.default.p `
	font-size: ${theme_1.theme.fontSizes.l};
	line-height: 1.5;
	margin-bottom: 0.75rem;
	max-width: 28rem;
`;
const Body = styled_components_1.default.p `
	font-size: ${theme_1.theme.fontSizes.m};
	line-height: 1.55;
	color: ${theme_1.theme.color.gray8};
	margin-bottom: 0;
	max-width: 28rem;
`;
const HomeButton = (0, styled_components_1.default)(elements_1.Button) `
	margin-top: 1.75rem;
`;
function deletionKindFromSession(raw) {
    if (raw === 'company') {
        return 'company';
    }
    // Legacy `'1'` and any other value: treat as candidate flow
    return 'candidate';
}
/**
 * Shown after successful candidate account deletion or company data removal (sessionStorage gate).
 * Direct visits redirect home.
 */
const AccountDeletionThankYou = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const [visible, setVisible] = react_1.default.useState(false);
    const [kind, setKind] = react_1.default.useState('candidate');
    react_1.default.useEffect(() => {
        const token = sessionStorage.getItem(account_deletion_1.POST_ACCOUNT_DELETION_SESSION_KEY);
        if (!token) {
            const lang = (0, localized_path_1.getLanguageFromPathname)(history.location.pathname);
            history.replace((0, localized_path_1.getLocalizedPath)('/', lang));
            return;
        }
        setKind(deletionKindFromSession(token));
        sessionStorage.removeItem(account_deletion_1.POST_ACCOUNT_DELETION_SESSION_KEY);
        setVisible(true);
    }, [history]);
    if (!visible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(elements_1.Holder, { marginVertical: true, "data-cy": "account-deletion-thank-you", children: (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsxs)(LayoutCol, { xs: 22, sm: 20, md: 18, lg: 16, children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { span: 24, style: { textAlign: 'center' }, children: (0, jsx_runtime_1.jsx)(Title, { level: 2, type: "secondary", style: { marginBottom: '1.25rem' }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: kind === 'company'
                                        ? 'admin.company_removal.thank_you.title'
                                        : 'profile.delete_account.thank_you.title' }) }) }) }), (0, jsx_runtime_1.jsxs)(ThankYouPanel, { children: [(0, jsx_runtime_1.jsx)(IconWrap, { "aria-hidden": true, children: (0, jsx_runtime_1.jsx)(icons_1.CheckCircleFilled, { style: { fontSize: '2.75rem', color: theme_1.theme.color.success } }) }), (0, jsx_runtime_1.jsx)(Lead, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: kind === 'company'
                                        ? 'admin.company_removal.thank_you.lead'
                                        : 'profile.delete_account.thank_you.lead' }) }), (0, jsx_runtime_1.jsx)(Body, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: kind === 'company'
                                        ? 'admin.company_removal.thank_you.body'
                                        : 'profile.delete_account.thank_you.body' }) }), (0, jsx_runtime_1.jsxs)(HomeButton, { link: "/", type: "primary", children: [(0, jsx_runtime_1.jsx)(icons_1.HomeOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.home" })] })] })] }) }) }));
};
exports.default = AccountDeletionThankYou;
